module.exports = __webpack_public_path__ + "img/bg-smooth.f525d86c.png";